<div class="dialog">
  <app-svg class="big-icon" src="/assets/icons/download.svg" size="2"></app-svg>
  <h1>Download All</h1>
  <p>
    Your <b>{{ totalSize | dataUnitsBigInt: 2 }}</b> download needs to be split across multiple ZIP-files. Are you sure
    you want to download everything?
  </p>
  <button
    appButton
    name="download"
    location="download-all-dialog"
    color="primary"
    (click)="close(true)"
    height="4"
    shape="round"
    size="3"
    weight="bold"
    spacing="full"
  >
    Download All
  </button>
  @if (amAllowed) {
    <button
      appButton
      name="individual"
      location="download-all-dialog"
      color="simple-gray"
      (click)="close('am')"
      size="3"
      shape="round"
      height="1"
      weight="bold"
      class="sub-cta"
      [center]="true"
    >
      Select Individual
    </button>
  }
  @if (!amAllowed) {
    <button
      appButton
      name="cancel"
      location="download-all-dialog"
      color="simple-gray"
      (click)="close(false)"
      size="3"
      shape="round"
      height="1"
      weight="bold"
      class="sub-cta"
      [center]="true"
    >
      Cancel
    </button>
  }
</div>
